// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA1erRWxY3hIXN5QMVWKcqCz5E8KGBoobg",
  authDomain: "emthonjeniwcdc-a002f.firebaseapp.com",
  projectId: "emthonjeniwcdc-a002f",
  storageBucket: "emthonjeniwcdc-a002f.firebasestorage.app",
  messagingSenderId: "260341300030",
  appId: "1:260341300030:web:7c23543e6754e1242f4a6f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);